import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import { useConversationsListStore } from '@/src/features/message/stores/useConversationsListStore'
import { ErrorMessage } from '@/src/general/components/ErrorMessage'
import { useDimensions } from '@/src/general/hooks/useDimensions'

import { useConversationsPreviewQuery } from '../../../../services/useConversationsPreviewQuery'
import { ConversationPreviewList } from '../../../components/ConversationPreviewList/ConversationPreviewList'
import { ConversationPlaceholder } from './ConversationPlaceholder'
import { EmptyMessagesScreen } from './EmptyMessageScreen'
import { NoSelectedConversationLayout } from './NoSelectedConversationLayout'

type TNoSelectedConversationProps = {
  conversationId: number | undefined
  openedConversationId: number | undefined
}

export const NoSelectedConversation = ({
  conversationId,
  openedConversationId,
}: TNoSelectedConversationProps): ReactNode => {
  const { xs } = useDimensions()

  const unread = useConversationsListStore((state) => state.unread)
  const { data: conversations, error } = useConversationsPreviewQuery()

  const renderContent = () => {
    if (xs) {
      if (!unread && conversations && conversations.length === 0) return <EmptyMessagesScreen />
      if (conversations || !error)
        return <ConversationPreviewList conversationId={conversationId} openedConversationId={openedConversationId} />
      return <ErrorMessage defaultErrorKey="common.error.unknown" />
    }

    if (error) return <ErrorMessage defaultErrorKey="common.error.unknown" />
    if (!conversations) return <ConversationPlaceholder />
    if (!unread && conversations && conversations.length === 0) return <EmptyMessagesScreen />

    return (
      <View className="flex-1 items-center justify-center">
        <Typography>
          <FormattedMessage id="message.unselected" />
        </Typography>
      </View>
    )
  }

  return <NoSelectedConversationLayout>{renderContent()}</NoSelectedConversationLayout>
}
